/**
 * Created by or_p on 10/4/2016.
 */
import _ from 'lodash';

export function anyDialogOpen(state) {
  if (state.publishDialog.open) {
    return true;
  }
  if (_.some(state.panel.openedLazyPanels, panel => (panel.open))) {
    return true;
  }
  if (!_.isEmpty(state.routing.location.query.openDialog)) {
    return true;
  }
  if (!_.isEmpty(state.panel.openedStaticPanels)) {
    return true;
  }
  return false;
}
